// Один QueryClient на всё приложение. Конфиг — консервативный, под live-данные
// owner панели (handoff `03 §`, polling 30s для agents/health):
//   - `staleTime: 15s` — не дёргаем чаще, чем раз в 15 секунд при перерендере
//   - `gcTime: 5 минут` — кэш живёт после unmount, чтобы возврат на экран
//     не показывал skeleton'ы лишний раз
//   - `retry: 1` — одна попытка повтора при сетевой ошибке (не для 401/403/404)
//   - `refetchOnWindowFocus: true` — owner возвращается в таб и видит свежие данные
//
// `useQuery` / `useMutation` подключаются прямо из `@tanstack/react-query` — этот
// модуль только держит singleton QueryClient.

import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          // Не повторяем при 4xx — это «оно так и есть», а не флапающая сеть.
          if (error.status >= 400 && error.status < 500) return false
        }
        return failureCount < 1
      },
    },
    mutations: {
      // Mutations — destructive: повторов не делаем, лучше пусть пользователь
      // нажмёт ещё раз сам и увидит, что произошло.
      retry: false,
    },
  },
})
